<template>
    <div class="bg-white w-full md:w-4/5 rounded shadow mx-auto">
        <div class="grid grid-cols-2 gap-32 p-32 sm:p-64">
            <div class="my-auto col-span-full lg:col-span-1">
                <h1 class="font-semibold text-big text-ellipsis overflow-hidden leading-tight">{{ ucfirst(title) }}</h1>
                <h2 class="font-semibold text-big text-secondary text-ellipsis overflow-hidden mb-32">{{ ucfirst(subtitle) }}</h2>

                <slot></slot>
            </div>
            <img class="my-auto hidden lg:block" src="/app/img/two-factor-laptop.png" />
        </div>
    </div>
</template>

<script>

import {ucfirst} from "../../shared/helpers";

export default {
    methods: {ucfirst},
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        subtitle: {
            type: String,
            required: false,
            default: ''
        },
    }
};
</script>

<style scoped>

</style>
